import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable camelcase */
import { useRouter } from 'next/router';
import { useMemo } from 'react';
// useTrackingData is responsible for getting data from url params and merging with passed parameters
// to fulfill contract requirements;
// Checks if strackid & trackid are available in url params,
// and if it's true sets them into rio data with tracking_type as search.
export var useTrackingData = function useTrackingData(params) {
  var router = useRouter();
  var _router$query = router.query,
    strackid = _router$query.strackid,
    trackid = _router$query.trackid,
    recommendation_id = _router$query.recommendation_id;
  var _ref = params !== null && params !== void 0 ? params : {},
    tracking_type = _ref.tracking_type,
    content_label = _ref.content_label,
    content_id = _ref.content_id,
    section_id = _ref.section_id,
    region_name = _ref.region_name;
  return useMemo(function () {
    if ((tracking_type === 'search' || !tracking_type) && strackid && typeof strackid === 'string' && trackid && typeof trackid === 'string') {
      return _objectSpread(_objectSpread({}, params), {}, {
        tracking_type: 'search',
        search_track_id: trackid,
        search_strack_id: strackid
      });
    }
    if ((tracking_type === 'recommendation' || !tracking_type) && recommendation_id && typeof recommendation_id === 'string') {
      return _objectSpread(_objectSpread({}, params), {}, {
        tracking_type: 'recommendation',
        recommendation_id: recommendation_id
      });
    }
    if (tracking_type) {
      return params;
    }
    return _objectSpread({
      tracking_type: null
    }, params);
  }, [strackid, trackid, tracking_type, content_label, content_id, section_id, region_name]);
};
export default useTrackingData;